export const GET_PROFILE = "GET_PROFILE";
export const GET_TOKEN = "GET_TOKEN";
export const GET_IS_MEMBER = "GET_IS_MEMBER";
export const GET_IS_INTERN_REQUEST = "GET_IS_INTERN_REQUEST";

export const updateProfile = (data) => {
  return {
    type: GET_PROFILE,
    payload: {
      profile: data,
    },
  };
};

export const updateToken = async (data) => {
  return {
    type: GET_TOKEN,
    payload: {
      token: data,
    },
  };
};
export const updateIsMember = async (data) => {
  return {
    type: GET_IS_MEMBER,
    payload: {
      isMember: data,
    },
  };
};
export const updateIsInternRequest = async (data) => {
  return {
    type: GET_IS_INTERN_REQUEST,
    payload: {
      isInternRequest: data,
    },
  };
};
